import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'zamawianie do stolika',
    [ORDER_METHODS.PICKUP]: 'odbiór',
    [ORDER_METHODS.DELIVERY]: 'dostawa',
  },
  errors: {
    draft_validation_failed: 'Uzupełnij adres dostawy przed kontynuowaniem.',
  },
};
